import React from "react";
import { Localize } from "components/service";
import type { TCommunicationTask } from "../helpers/communication-types-helper";

interface ICommunicationNextStepFieldProps {
  task: TCommunicationTask;
}

const getNextStepKey = (task: TCommunicationTask): string => {
  if (task.status === "unidentified") {
    return "COMMUNICATION.NextStep_Match";
  }

  if (task.status === "pending") {
    return "COMMUNICATION.NextStep_Review";
  }

  if (task.status === "dismissed") {
    return "COMMUNICATION.NextStep_History";
  }

  return "COMMUNICATION.NextStep_History";
};

const CommunicationNextStepField: React.FC<ICommunicationNextStepFieldProps> = ({ task }) => (
  <span className={`communication-next-step communication-next-step--${task.status}`}>
    <Localize>{getNextStepKey(task)}</Localize>
  </span>
);

export default CommunicationNextStepField;
